// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f2d90f36","682":"4e8082b3","803":"8deb740b"}[chunkId] + ".chunk.js";
};